import { useService } from "./service.js";
function isTouchEvent(event) {
  return typeof TouchEvent !== "undefined" && event instanceof TouchEvent;
}
const events = ["mousemove", "touchmove", "mousedown", "touchstart", "mouseup", "touchend"];
function createPointerService() {
  function updateProps(event) {
    props.event = event;
    const yLast = props.y;
    const xLast = props.x;
    const y = isTouchEvent(event) ? event.touches[0]?.clientY : event.clientY;
    if (y !== props.y) {
      props.y = y;
    }
    const x = isTouchEvent(event) ? event.touches[0]?.clientX : event.clientX;
    if (x !== props.x) {
      props.x = x;
    }
    props.changed.x = props.x !== xLast;
    props.changed.y = props.y !== yLast;
    props.last.x = xLast;
    props.last.y = yLast;
    props.delta.x = props.x - xLast;
    props.delta.y = props.y - yLast;
    props.max.x = window.innerWidth;
    props.max.y = window.innerHeight;
    props.progress.x = props.x / props.max.x;
    props.progress.y = props.y / props.max.y;
    return props;
  }
  function handleEvent(event) {
    switch (event.type) {
      case "mouseenter":
      case "mousemove":
      case "touchmove":
        trigger(updateProps(event));
        break;
      case "mousedown":
      case "touchstart":
        props.isDown = true;
        trigger(props);
        break;
      case "mouseup":
      case "touchend":
        props.isDown = false;
        trigger(props);
        break;
    }
  }
  const { add, remove, has, trigger, props } = useService({
    props: {
      event: null,
      isDown: false,
      x: window.innerWidth / 2,
      y: window.innerHeight / 2,
      changed: {
        x: false,
        y: false
      },
      last: {
        x: window.innerWidth / 2,
        y: window.innerHeight / 2
      },
      delta: {
        x: 0,
        y: 0
      },
      progress: {
        x: 0.5,
        y: 0.5
      },
      max: {
        x: window.innerWidth,
        y: window.innerHeight
      }
    },
    init() {
      document.documentElement.addEventListener("mouseenter", handleEvent, {
        once: true,
        capture: true
      });
      const options = { passive: true, capture: true };
      events.forEach((event) => {
        document.addEventListener(event, handleEvent, options);
      });
    },
    kill() {
      events.forEach((event) => {
        document.removeEventListener(event, handleEvent);
      });
    }
  });
  return {
    add,
    remove,
    has,
    props: () => props
  };
}
let pointer;
function usePointer() {
  if (!pointer) {
    pointer = createPointerService();
  }
  return pointer;
}
export {
  usePointer as default
};
//# sourceMappingURL=pointer.js.map
